"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var notificationBannerBaseTheme = function (_a) {
    var _b, _c, _d;
    var MAX_XS = _a.MAX_XS, MAX_S = _a.MAX_S, MIN_S = _a.MIN_S;
    return ({
        notificationBanner: {
            minHeight: "50px",
            display: "flex",
            position: "relative",
            alignItems: "center",
            alignContent: "center",
            width: "100%",
            order: 2,
        },
        notificationBannerWrapper: (_b = {
                height: "100%",
                display: "flex",
                alignItems: "center",
                alignContent: "center",
                margin: "0 auto"
            },
            _b[MAX_S] = {
                "& i18n-message": {
                    fontSize: "0.75rem !important",
                }
            },
            _b),
        notificationBannerText: (_c = {
                fontSize: "1rem",
                lineHeight: "1rem",
                marginLeft: "1rem",
                display: "flex",
                flex: 1,
                alignItems: "center",
                alignContent: "center"
            },
            _c[MAX_S] = {
                fontSize: "0.75rem !important",
            },
            _c[MAX_XS] = {
                flexDirection: "column",
            },
            _c["&::before"] = {
                display: 'inline-block',
                content: '"\\00a0"'
            },
            _c),
        notificationBannerHref: (_d = {
                margin: "0",
                borderBottom: "1px solid rgb(0, 154, 217)",
                borderCollapse: "collapse",
                lineHeight: "0.675rem"
            },
            _d[MIN_S] = {
                lineHeight: "0.875rem",
            },
            _d.whiteSpace = "nowrap",
            _d),
        notificationBannerIcon: "forum",
    });
};
exports.default = notificationBannerBaseTheme;
//# sourceMappingURL=notificationBanner.js.map